import React from 'react';
import {Bling as GPT} from "react-gpt";
//import Ads from "../../ad-config";
GPT.enableSingleRequest();

export default class Ros_Left_300_250 extends React.Component {
        render() {
            let Ads = this.props.AdData;
            return (          
    <>
     {(() => {
          if (Object.keys(Ads).length> 0 ) {
            return (
                <GPT 
                adUnitPath={Ads.adunitPath_rosLeft300250}
                name={Ads.name_rosLeft300250}
                 slotSize={[300, 250]}
    />
            )
          } 
        })()}
    </>
            )
        }
    }